import React from "react";
import userImage from "../../assets/profilePnc.png";

const ProfileSection = ({ handleProfileClick }) => {
  // Function to extract the name before @ from an email
  const extractNameFromEmail = (email) => {
    if (!email) return "";
    return email.split("@")[0];
  };

  const storedUsername =
    sessionStorage.getItem("username") ||
    localStorage.getItem("username") ||
    "";
  const displayName = extractNameFromEmail(storedUsername);

  return (
    <div
      className="flex items-center py-3 border-gray-200 mt-auto cursor-pointer"
      onClick={handleProfileClick}
    >
      <div className="w-8 h-8 rounded-full flex items-center justify-center mr-3">
        <img
          src={userImage}
          alt="profile"
          className="cursor-pointer profilePnc"
        />
      </div>
      <span className="text-sm font-medium profileMobile">{displayName}</span>
      <svg
        className="ml-auto"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 9L12 15L18 9"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default ProfileSection;
